import * as React from 'react';
import MainContent from './MainContent';
import DeedsySpinner from './components/DeedsySpinner';
import useAccounts from './hooks/useAccountsHook';
import { isEmptyOrNil } from './utilities/hasValue';

const App: React.FC<{}> = () => {
  const { accountRoles } = useAccounts();

  if (isEmptyOrNil(accountRoles)) {
    return <DeedsySpinner />
  }

  return (
    <React.Fragment>
      <MainContent />
    </React.Fragment>
  );
}

export default App;
